var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-16 text-center grey--text"},[_vm._v(" "+_vm._s(_vm.$t(("" + _vm.text)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }